export const adiquimica = {
  adiquimica_discrepancy_po_empty:
    "No Purchase Order (PO) found for document number: {{0}}.",

  adiquimica_discrepancy_invoice_po_not_found:
    "Invoice with document number {{0}} has no matching PO with number {{1}}.",

  adiquimica_discrepancy_dn_po_not_found:
    "Delivery note with document number {{0}} has no matching PO with number {{1}}.",

  adiquimica_discrepancy_invoice_po_amount_not_match:
    "Invoice total amount {{2}} for document {{0}} with PO number {{1}} does not match PO total amount {{3}}.",

  adiquimica_discrepancy_invoice_po_amountwithouttax_not_match:
    "Invoice amount without tax {{2}} for document {{0}} and PO number {{1}} does not match PO amount without tax {{3}}.",

  adiquimica_discrepancy_no_items: "No items found.",

  adiquimica_discrepancy_item_adiquimicaitem_empty:
    'Invoice item #"{{0}}" with description "{{1}}" has no matching item in the PO.',

  adiquimica_discrepancy_item_po_item_matching_notfound:
    'No matching PO item found for item at index {{0}} with description "{{1}}".',

  adiquimica_discrepancy_item_po_mismatch:
    'Item "{{1}}" at index {{0}} has a PO number mismatch: Document PO is {{2}}, but the item\'s PO number is {{3}}.',

  adiquimica_discrepancy_item_unitprice_mismatch:
    'Unit price for item "{{1}}" at index {{0}} is "{{2}}", which does not match the PO price of {{3}}.',

  adiquimica_discrepancy_item_amount_mismatch:
    'Amount for item "{{1}}" at index {{0}} is {{2}}, which does not match the PO base amount of {{3}} (calculated as Net Price × Quantity).',

  adiquimica_discrepancy_item_quantity_mismatch:
    'Quantity for item "{{1}}" at index {{0}} is {{2}}, which does not match the PO quantity of {{3}}.',

  adiquimica_discrepancy_itemamount_shouldbe_between_8and10: `Item "{{1}}" amount must be between 8 and 12; found {{2}}.`,

  adiquimica_discrepancy_itemunitprice_shouldbe_between_8and10: `Item "{{1}}" unit price must be between 8 and 12; found {{2}}.`,
  adiquimica_currency_missmatch:
    'Currency mismatch. Expected currency:"€" but found {{0}}.',
  adiquimica_description_contains_proyecto:
    'Description "{{0}}" contains the word "proyecto".',
  adiquimica_item_vatcode_cc:
    "Invalid Adiquimica PO item VAT code in item row # {{0}}.",
  adiquimica_item_vatcode_0:
    "Missing Adiuimica PO item VAT code in item row # {{0}}.",
  adiquimica_ponumber_mustbe_8characters: `PO number "{{0}}" must be 8 characters`,
  adiquimica_ponumber_muststartwith_222: `PO number "{{0}}" must start with "222"`,
  adiquimica_dn_po_not_attached: `Delivery Note not attached, referenced in Invoice '#{{0}}'.`,
  adiquimica_delivery_note_not_found: `Delivery note '#{{0}}' not found in Invoice '#{{2}}'`,
  adiquimica_invoice_item_count_miss_match: `The item count in Invoice '#{{2}}' does not match the item count in Delivery Note '#{{0}}'.`,
  adiquimica_delivery_note_delivery_date_missing: `Delivery date (FechaEntrega) is empty in Delivery Note '#{{0}}' referenced in Invoice '#{{2}}'. Fill it in the Delivery Note and re-process the Invoice.`,
};
